import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../../layout/service/user.service';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule, Table } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TextareaModule } from 'primeng/textarea';
import { TabsModule } from 'primeng/tabs';
import { EditorModule } from 'primeng/editor';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { ActivatedRoute, Router } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';

pdfMake.vfs = pdfFonts['vfs'] as unknown as { [file: string]: string };
@Component({
    selector: 'app-tutor',
    imports: [
        SelectModule,
        InputTextModule,
        TableModule,
        FormsModule,
        DialogModule,
        MessageModule,
        ButtonModule,
        ToastModule,
        CommonModule,
        ProgressBarModule,
        RadioButtonModule,
        TextareaModule,
        EditorModule,
        TooltipModule
    ],
    providers: [MessageService],
    template: `
        <p-toast />
        <div class="relative">
            <!-- Hapus tombol Mulai Evaluasi dan dialog -->
            <div class="card">
                <div class="flex justify-between items-center mb-3">
                    <h3 class="text-primary">Checklist</h3>
                    <div class="flex items-center gap-2">
                        <p-button
                            label="Lihat Riwayat"
                            icon="pi pi-history"
                            [raised]="true"
                            severity="info"
                            styleClass="p-button-sm mr-2"
                            (onClick)="goToHistory()">
                        </p-button>
                        <div class="flex items-center gap-2">
                            <input
                                pInputText
                                type="text"
                                [(ngModel)]="searchTitleKeyword"
                                placeholder="Cari judul..."
                                class="w-64 md:w-80 notice-input" />
                            <p-button
                                type="button"
                                icon="pi pi-search"
                                class="p-button-text"
                                (onClick)="onSearchTitle()">
                            </p-button>
                        </div>
                    </div>
                </div>
                <p-progressbar *ngIf="loading" mode="indeterminate" [style]="{ height: '8px' }"></p-progressbar>
                <div *ngIf="!loading">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div class="col-span-1">
                            <div class="flex flex-col gap-2">
                                <label for="level">Level</label>
                                <p-select
                                    [options]="levelOptions"
                                    [(ngModel)]="selectedLevel"
                                    optionLabel="label"
                                    optionValue="value"
                                    [showClear]="true"
                                    placeholder="Pilih level"
                                    class="w-full"
                                    (onChange)="onLevelChange()">
                                </p-select>
                            </div>
                        </div>
                        <div class="col-span-1" *ngIf="selectedLevel">
                            <div class="flex flex-col gap-2">
                                <label for="category">Kategori</label>
                                <p-select
                                    [options]="filteredCategories"
                                    [filter]="true"
                                    filterBy="KATEGORI"
                                    [(ngModel)]="selectedCategory"
                                    optionLabel="KATEGORI"
                                    [showClear]="true"
                                    placeholder="Pilih kategori"
                                    class="w-full"
                                    (onChange)="onCategoryChange(); selectedTitle=null; searchTitleKeyword=''; mahasiswa=''; universitas=''; forms=[];">
                                </p-select>
                            </div>
                        </div>
                        <div class="col-span-1" *ngIf="selectedCategory">
                            <div class="flex flex-col gap-2">
                                <label for="title">Judul</label>
                                <p-select
                                    [options]="titles"
                                    [filter]="true"
                                    filterBy="TITLE"
                                    [(ngModel)]="selectedTitle"
                                    optionLabel="TITLE"
                                    [showClear]="true"
                                    placeholder="Pilih judul"
                                    class="w-full"
                                    (onChange)="mahasiswa=''; universitas=''; forms=[]; getFormDetail();">
                                </p-select>
                            </div>
                        </div>
                        <div class="col-span-1" *ngIf="selectedCategory && selectedTitle">
                            <div class="flex flex-col gap-2">
                                <label for="student">Nama Mahasiswa</label>
                                <input type="text" pInputText [(ngModel)]="mahasiswa" placeholder="Nama mahasiswa" class="w-full" />
                            </div>
                        </div>
                        <div class="col-span-1" *ngIf="selectedCategory && selectedTitle">
                            <div class="flex flex-col gap-2">
                                <label for="university">Universitas</label>
                                <input type="text" pInputText [(ngModel)]="universitas" placeholder="Nama universitas" class="w-full" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-between items-center" *ngIf="selectedCategory && selectedTitle">
                <div>
                    <h4 style="color:#3D5C99;">SKDI - {{ selectedTitle?.SKDI }}</h4>
                </div>
                <div class="flex justify-end mt-3 gap-2" *ngIf="selectedCategory && selectedTitle">
                    <p-button
                        label="Simpan Form"
                        [raised]="true"
                        icon="pi pi-save"
                        (onClick)="saveReport()"
                        severity="primary"
                        styleClass="!bg-[#0874DF1A] !text-[#0874DF]"
                        [disabled]="!mahasiswa || !universitas">
                    </p-button>
                    <p-button
                        label="Bersihkan Form"
                        [raised]="true"
                        icon="pi pi-trash"
                        (onClick)="clearForm()"
                        severity="danger"
                        styleClass="!bg-[#C915151A] !text-[#C91515]"
                        [disabled]="!mahasiswa && !universitas">
                    </p-button>
                </div>
            </div>
            <div class="mt-4" *ngIf="selectedCategory && selectedTitle" class="flex gap-4">
                <div class="flex-1">
                    <p-table [value]="forms" [loading]="loading" [tableStyle]="{ 'min-width': '50rem' }" styleClass="mt-5">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="background:none !important;color:#939393;font-weight:900;font-size:1.2rem;" class="w-10 text-center">No</th>
                                <th style="background:none !important;color:#939393;font-weight:900;font-size:1.2rem;" class="text-center">Kegiatan</th>
                                <th colspan="4" style="background:none !important;color:#939393;font-weight:900;font-size:1.2rem;" class="text-center">Skor</th>
                                <th style="background:none !important;color:#939393;font-weight:900;font-size:1.2rem;" class="w-40 text-center">Komentar</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-form let-i="rowIndex">
                            <tr *ngIf="form.IS_HEADER === '1'" style="margin-top:2rem !important"> 
                                <td colspan="7" class="font-bold text-center !rounded-t-lg bg-primary text-white" [innerHTML]="sanitizeHtml(form.ACTIVITY)"></td>
                            </tr>
                            <tr *ngIf="form.IS_HEADER === '0'" [ngClass]="{'bg-blue-50 border-l-4 border-blue-200': form.NOTE && form.NOTE.trim() !== ''}">
                                <td class="text-center">
                                    <span class="text-md" style="border-radius:12px;padding:10px 15px;background:#ACE5F5;color:#0D6E8A;font-weight:bold;">{{ getActivityNumber(i) }}</span>
                                </td>
                                <td [innerHTML]="sanitizeHtml(form.ACTIVITY)"></td>
                                <td class="text-center p-0">
                                    <div class="score-box" 
                                         [ngClass]="{'selected': form.SKOR === '0'}"
                                         (click)="selectScore(form, '0')">
                                        0
                                    </div>
                                </td>
                                <td class="text-center p-0">
                                    <div class="score-box" 
                                         [ngClass]="{'selected': form.SKOR === '1'}"
                                         (click)="selectScore(form, '1')">
                                        1
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="score-box p-0" 
                                         [ngClass]="{'selected': form.SKOR === '2'}"
                                         (click)="selectScore(form, '2')">
                                        2
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="score-box p-0" 
                                         [ngClass]="{'selected': form.SKOR === '3'}"
                                         (click)="selectScore(form, '3')">
                                        3
                                    </div>
                                </td>
                                <td class="">
                                    <div class="flex items-center gap-2">
                                        <i *ngIf="form.NOTE && form.NOTE.trim() !== ''" class="pi pi-comment text-blue-500" pTooltip="Ada catatan" tooltipPosition="left"></i>
                                        <textarea rows="5" cols="30" name="note-{{ i }}" [(ngModel)]="form.NOTE" placeholder="Catatan" class="custom-textarea flex-1"></textarea>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <div *ngIf="osceNotes.length > 0" class="w-80 sticky top-20 h-fit self-start pt-10">
                    <div class="bg-white rounded-xl shadow-lg border border-gray-200 p-4 max-h-96 overflow-y-auto">
                        <div class="flex items-center gap-3 mb-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-blue-600">
                                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                                <polyline points="14 2 14 8 20 8"></polyline>
                            </svg>
                            <h4 class="text-sm font-bold text-gray-800">Catatan OSCE ({{ osceNotes.length }})</h4>
                        </div>
                        <div class="space-y-3">
                            <div *ngFor="let note of osceNotes.slice(-3)" class="border-l-4 border-blue-500 bg-gray-50 rounded-lg p-3">
                                <div class="flex justify-between items-start gap-2 mb-2">
                                    <div class="prose prose-sm max-w-none flex-1 line-clamp-3" [innerHTML]="note.note"></div>
                                    <div class="flex gap-1 flex-shrink-0">
                                        <button 
                                            pButton 
                                            icon="pi pi-pencil" 
                                            class="p-button-sm p-button-text p-button-info"
                                            (click)="editOsceNote(note)">
                                        </button>
                                        <button 
                                            pButton 
                                            icon="pi pi-trash" 
                                            class="p-button-sm p-button-text p-button-danger"
                                            (click)="deleteOsceNote(note)">
                                        </button>
                                    </div>
                                </div>
                                <div class="text-xs text-gray-500">
                                    {{ formatNoteDate(note.created_at) }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="osceNotes.length > 3" class="text-center mt-3">
                            <button 
                                class="text-xs text-blue-600 hover:text-blue-800 underline cursor-pointer"
                                (click)="showAllNotesDialog = true">
                                Lihat {{ osceNotes.length - 3 }} catatan lainnya
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Dialog untuk hasil pencarian -->
        <p-dialog 
            [(visible)]="showSearchDialog" 
            [modal]="true" 
            [style]="{ width: '50rem' }"
            [draggable]="false"
            [resizable]="false"
            header="Hasil Pencarian">
            <div class="mt-3">
                <p-table 
                    #dialogDt
                    [value]="searchResults" 
                    [tableStyle]="{ 'min-width': '40rem' }"
                    [rowHover]="true"
                    [globalFilterFields]="['KATEGORI','TITLE']"
                    styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Kategori</th>
                            <th>Judul</th>
                            <th class="w-20">Aksi</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-result>
                        <tr style="cursor: pointer;" (click)="onSelectSearchResult(result)">
                            <td>{{ result.KATEGORI }}</td>
                            <td>{{ result.TITLE }}</td>
                            <td class="text-center">
                                <p-button 
                                    icon="pi pi-check" 
                                    [text]="true" 
                                    severity="success"
                                    label="Pilih">
                                </p-button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="empty">
                        <tr>
                            <td colspan="3" class="text-center">Tidak ada hasil ditemukan</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-dialog>
        
        <!-- Floating Notes Button -->
        <button 
            *ngIf="selectedTitle"
            class="fixed bottom-8 right-8 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 z-50"
            (click)="showNotesDialog = true"
            pTooltip="Tambah Catatan OSCE"
            tooltipPosition="left">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" x2="8" y1="13" y2="13"></line>
                <line x1="16" x2="8" y1="17" y2="17"></line>
                <line x1="10" x2="8" y1="9" y2="9"></line>
            </svg>
        </button>

        <!-- Notes Dialog -->
        <p-dialog 
            [(visible)]="showNotesDialog" 
            [modal]="true" 
            [style]="{width: '50vw'}" 
            [draggable]="false" 
            [resizable]="false"
            header="Tambah Catatan OSCE">
            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium mb-2 text-gray-700">Catatan Anda</label>
                    <p-editor [(ngModel)]="noteContent" [style]="{'height':'320px'}">
                    </p-editor>
                </div>
            </div>
            <ng-template pTemplate="footer">
                <div class="flex gap-2 justify-end">
                    <button pButton label="Batal" class="p-button-text" (click)="showNotesDialog = false"></button>
                    <button pButton label="Simpan" (click)="saveOsceNote()" [disabled]="!noteContent || noteContent.trim() === ''"></button>
                </div>
            </ng-template>
        </p-dialog>

        <!-- Edit Notes Dialog -->
        <p-dialog 
            [(visible)]="showEditDialog" 
            [modal]="true" 
            [style]="{width: '50vw'}" 
            [draggable]="false" 
            [resizable]="false"
            header="Edit Catatan OSCE">
            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium mb-2 text-gray-700">Catatan Anda</label>
                    <p-editor [(ngModel)]="editNoteContent" [style]="{'height':'320px'}">
                    </p-editor>
                </div>
            </div>
            <ng-template pTemplate="footer">
                <div class="flex gap-2 justify-end">
                    <button pButton label="Batal" class="p-button-text" (click)="cancelEdit()"></button>
                    <button pButton label="Simpan" (click)="updateOsceNote()" [disabled]="!editNoteContent || editNoteContent.trim() === ''"></button>
                </div>
            </ng-template>
        </p-dialog>

        <!-- All Notes Dialog -->
        <p-dialog 
            [(visible)]="showAllNotesDialog" 
            [modal]="true" 
            [style]="{width: '60vw'}" 
            [draggable]="false" 
            [resizable]="false"
            header="Semua Catatan OSCE">
            <div class="max-h-96 overflow-y-auto space-y-3">
                <div *ngFor="let note of osceNotes" class="border-l-4 border-blue-500 bg-gray-50 rounded-lg p-3 min-h-[80px]">
                    <div class="flex justify-between items-start gap-2 mb-2">
                        <div class="prose prose-sm max-w-none flex-1 line-clamp-3 overflow-hidden" [innerHTML]="note.note"></div>
                        <div class="flex gap-1 flex-shrink-0">
                            <button 
                                pButton 
                                icon="pi pi-pencil" 
                                class="p-button-sm p-button-text p-button-info"
                                (click)="editOsceNote(note); showAllNotesDialog = false;">
                            </button>
                            <button 
                                pButton 
                                icon="pi pi-trash" 
                                class="p-button-sm p-button-text p-button-danger"
                                (click)="deleteOsceNote(note)">
                            </button>
                        </div>
                    </div>
                    <div class="text-xs text-gray-500">
                        {{ formatNoteDate(note.created_at) }}
                    </div>
                </div>
            </div>
            <ng-template pTemplate="footer">
                <div class="flex justify-end">
                    <button pButton label="Tutup" class="p-button-text" (click)="showAllNotesDialog = false"></button>
                </div>
            </ng-template>
        </p-dialog>

        <p-toast></p-toast>
        
        <style>
            .score-box {
                width: 40px;
                height: 40px;
                background-color: #0000001A;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                font-weight: bold;
                font-size: 16px;
                color: #00000033;
                transition: all 0.3s ease;
                border-radius: 4px;
            }
            
            .score-box:hover {
                background-color: #0D8A4533;
                color: #000000;
            }
            
            .score-box.selected {
                background-color: #0D8A4533;
                color: #0D8A45;
            }

            .custom-textarea {
                border: 1px solid #00000033;
                border-radius: 4px;
                padding: 8px;
                resize: vertical;
                font-family: inherit;
                font-size: 14px;
            }

            .custom-textarea:focus {
                outline: none;
                border-color: #0D8A45;
                box-shadow: 0 0 0 2px rgba(13, 138, 69, 0.2);
            }
        </style>
    `
})
export class Tutor implements OnInit {

    categories: any[] = [];
    titles: any[] = [];
    mahasiswa: string = '';
    universitas: string = '';
    selectedCategory: any = null;
    selectedTitle: any = null;
    selectedLevel: string = '';
    showDialog: boolean = false;
    forms: any[] = [];
    loading: boolean = false;
    hasDetails: boolean = false;
    user = JSON.parse(localStorage.getItem('user') || '{}');
    fetchingData: boolean = false; // Tambahkan ini
    searchTitleKeyword: string = '';
    searchResults: any[] = [];
    showSearchDialog: boolean = false;
    @ViewChild('dialogDt') dialogDt!: Table;
    searchDialogKeyword: string = '';
    levelOptions = [
        { label: 'UKNPDPD', value: 'UKNPDPD' },
        { label: 'Preklinik', value: 'Preklinik' },
        { label: 'Koas', value: 'Koas' }
    ];
    showNotesDialog: boolean = false;
    noteContent: string = '';
    osceNotes: any[] = [];
    showEditDialog: boolean = false;
    editingNote: any = null;
    editNoteContent: string = '';
    showAllNotesDialog: boolean = false;

    get filteredCategories() {
        return this.categories.filter(cat => cat.LEVEL === this.selectedLevel);
    }

    constructor(
        private userService: UserService,
        private messageService: MessageService,
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit(): void {
        const storedDetails = localStorage.getItem('tutorDetails');
        this.initApi().then(() => {
            const osceId = this.route.snapshot.queryParams['osceId'];
            if (osceId) {
                this.findAndSelectOsce(osceId);
            }
        });
        if (storedDetails) {
            const parsedDetails = JSON.parse(storedDetails);
            this.hasDetails = true;
        }
    }

    openDialog(): void {
        this.showDialog = true;
        this.loading = false;
        this.selectedCategory = null;
        this.selectedTitle = null;
        this.mahasiswa = '';
        this.universitas = '';
        this.forms = [];
    }

    goToHistory(): void {
        this.router.navigate(['/app/osce/tutor/history']);
    }

    async initApi(): Promise<void> {
        try {
            const response = await this.userService.getCategoriesActive();
            this.categories = response.data;
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    }

    async findAndSelectOsce(osceId: string): Promise<void> {
        for (const category of this.categories) {
            try {
                const response = await this.userService.getOsceTitle({ ID_KATEGORI: category.ID });
                const titles = response.data;
                const title = titles.find((t: any) => t.ID_OSCE === osceId);
                if (title) {
                    this.selectedLevel = category.LEVEL;
                    this.selectedCategory = category;
                    this.titles = titles;
                    this.selectedTitle = title;
                    await this.getFormDetail();
                    break;
                }
            } catch (error) {
                console.error('Failed to fetch titles for category:', category.ID);
            }
        }
    }

    onLevelChange(): void {
        this.selectedCategory = null;
        this.selectedTitle = null;
        this.mahasiswa = '';
        this.universitas = '';
        this.forms = [];
        this.searchTitleKeyword = '';
    }

    async onCategoryChange(): Promise<void> {
        if (this.selectedCategory) {
            try {
                const response = await this.userService.getOsceTitle({ ID_KATEGORI: this.selectedCategory.ID });
                this.titles = response.data;
            } catch (error) {
                console.error('Failed to fetch titles:', error);
            }
        }
    }

    async onSearchTitle(event?: Event): Promise<void> {
        // When triggered by button, use bound model. If event provided, fall back to event target.
        let keyword = '';
        if (event && (event as any).target) {
            keyword = ((event.target as HTMLInputElement).value || '').trim();
        } else {
            keyword = (this.searchTitleKeyword || '').trim();
        }

        if (!keyword) {
            // Jika keyword kosong, tutup dialog dan reset
            this.searchResults = [];
            this.showSearchDialog = false;
            this.titles = [];
            return;
        }

        // Validasi minimum 3 huruf
        if (keyword.length < 3) {
            this.searchResults = [];
            this.showSearchDialog = false;
            this.messageService.add({ severity: 'warn', summary: 'Peringatan', detail: 'Masukkan minimal 3 karakter' });
            return;
        }

        try {
            const response = await this.userService.searchOsceTitle({ TITLE: keyword });

            if (response && response.data && response.data.length > 0) {
                this.searchResults = response.data;
                this.showSearchDialog = true;
            } else {
                this.searchResults = [];
                this.showSearchDialog = false;
                this.messageService.add({ severity: 'warn', summary: 'Peringatan', detail: 'Hasil tidak ditemukan' });
            }
        } catch (error) {
            console.error('Failed to search titles:', error);
            this.searchResults = [];
            this.showSearchDialog = false;
            this.messageService.add({ severity: 'warn', summary: 'Peringatan', detail: 'Hasil tidak ditemukan' });
        }
    }

    onInput(event: Event, dt: any) {
        const inputElement = event.target as HTMLInputElement;
        dt.filterGlobal(inputElement.value, 'contains');
    }

    async onSelectSearchResult(result: any): Promise<void> {
        // Cari kategori yang sesuai dari categories array
        const category = this.categories.find(cat =>
            cat.ID === result.ID_KATEGORI || cat.KATEGORI === result.KATEGORI
        );

        if (category) {
            this.selectedLevel = category.LEVEL;
            this.selectedCategory = category;
            // Load titles untuk kategori yang dipilih
            await this.onCategoryChange();

            // Cari title yang sesuai dari titles array
            const title = this.titles.find(t =>
                t.ID_OSCE === result.ID_OSCE || t.TITLE === result.TITLE
            );

            if (title) {
                this.selectedTitle = title;
                // Reset form fields
                this.mahasiswa = '';
                this.universitas = '';
                this.forms = [];
                // Clear search keyword
                this.searchTitleKeyword = '';
                // Close dialog
                this.showSearchDialog = false;
                // Load form details
                await this.getFormDetail();
            } else {
                // Jika title tidak ditemukan, set langsung dari result
                this.selectedTitle = {
                    ID_OSCE: result.ID_OSCE,
                    TITLE: result.TITLE,
                    SKDI: result.SKDI
                };
                this.mahasiswa = '';
                this.universitas = '';
                this.forms = [];
                this.searchTitleKeyword = '';
                this.showSearchDialog = false;
                await this.getFormDetail();
            }
        } else {
            // Jika kategori tidak ditemukan, coba set langsung dari result
            this.selectedCategory = {
                ID: result.ID_KATEGORI,
                KATEGORI: result.KATEGORI
            };
            await this.onCategoryChange();

            const title = this.titles.find(t =>
                t.ID_OSCE === result.ID_OSCE || t.TITLE === result.TITLE
            );

            if (title) {
                this.selectedTitle = title;
            } else {
                this.selectedTitle = {
                    ID_OSCE: result.ID_OSCE,
                    TITLE: result.TITLE,
                    SKDI: result.SKDI
                };
            }

            this.mahasiswa = '';
            this.universitas = '';
            this.forms = [];
            this.searchTitleKeyword = '';
            this.showSearchDialog = false;
            await this.getFormDetail();
        }
    }

    async getFormDetail(): Promise<void> {
        this.loading = true;
        try {
            const response = await this.userService.getOsceDetail(
                { ID_KATEGORI: this.selectedCategory.ID, ID_OSCE: this.selectedTitle.ID_OSCE }
            );
            this.forms = response.data.FORM;
            // Load notes for this OSCE
            this.loadOsceNotes();

            // Auto-fill form from history API & local draft
            await this.loadTutorHistory();
        } catch (error) {
            console.error('Failed to fetch form details:', error);
        } finally {
            this.loading = false;
        }
    }

    async loadTutorHistory(): Promise<void> {
        if (!this.selectedTitle || !this.forms || this.forms.length === 0) return;

        const osceId = this.selectedTitle.ID_OSCE;
        const username = this.user?.USERNAME || this.user?.name || '';

        // 1. First check localStorage for local cached draft for this OSCE and tutor
        const localKey = `tutor_form_${username}_${osceId}`;
        const localDataRaw = localStorage.getItem(localKey);
        if (localDataRaw) {
            try {
                const localData = JSON.parse(localDataRaw);
                if (localData.mahasiswa) this.mahasiswa = localData.mahasiswa;
                if (localData.universitas) this.universitas = localData.universitas;
                if (Array.isArray(localData.answers)) {
                    for (const form of this.forms) {
                        if (form.IS_HEADER === '0') {
                            const match = localData.answers.find((a: any) => a.ID_DETAIL_OSCE === form.ID_DETAIL_OSCE);
                            if (match) {
                                form.SKOR = match.SKOR !== undefined && match.SKOR !== null ? String(match.SKOR) : form.SKOR;
                                form.NOTE = match.NOTE ?? match.KOMENTAR ?? form.NOTE;
                            }
                        }
                    }
                }
            } catch { }
        }

        // 2. Fetch history from API database to populate latest report history
        try {
            const res = await this.userService.getOsceResult();
            if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
                // Filter report for this title and tutor (or latest report for this title)
                const matchingReports = res.data.filter((r: any) => {
                    const matchesTitle = String(r.JUDUL).trim().toLowerCase() === String(this.selectedTitle.TITLE).trim().toLowerCase();
                    const matchesUser = !username || String(r.CREATED_BY).trim().toLowerCase() === String(username).trim().toLowerCase();
                    return matchesTitle && matchesUser;
                });

                if (matchingReports.length > 0) {
                    // Get latest report (last element in array or highest ID)
                    const latestReport = matchingReports[matchingReports.length - 1];
                    const reportId = latestReport.id || latestReport.ID || latestReport.ID_REPORT;

                    if (!this.mahasiswa && latestReport.MAHASISWA) {
                        this.mahasiswa = latestReport.MAHASISWA;
                    }
                    if (!this.universitas && latestReport.UNIVERSITAS) {
                        this.universitas = latestReport.UNIVERSITAS;
                    }

                    if (reportId) {
                        const detailRes = await this.userService.detailOsceResult({ ID_REPORT: reportId });
                        if (detailRes && detailRes.data && Array.isArray(detailRes.data)) {
                            const details = detailRes.data;
                            for (const form of this.forms) {
                                if (form.IS_HEADER === '0') {
                                    const match = details.find((d: any) => String(d.ID_OSCE_DETAIL) === String(form.ID_DETAIL_OSCE));
                                    if (match) {
                                        if (form.SKOR === undefined || form.SKOR === null || form.SKOR === '') {
                                            if (match.BOBOT !== undefined && match.BOBOT !== null) {
                                                form.SKOR = String(match.BOBOT);
                                            }
                                        }
                                        if (!form.NOTE) {
                                            if (match.KOMENTAR !== undefined && match.KOMENTAR !== null) {
                                                form.NOTE = match.KOMENTAR;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } catch (error) {
            console.error('Failed to load tutor report history from API:', error);
        }
    }

    loadOsceNotes(): void {
        const userStr = localStorage.getItem('user');
        let userId = '1';
        if (userStr) {
            const user = JSON.parse(userStr);
            userId = user.ID_USER || '1';
        }

        this.userService.getNotes(userId).then(
            (response) => {
                const data = response.data || response;
                const allNotes = data.notes || data.data || (Array.isArray(data) ? data : []);
                this.osceNotes = allNotes.filter((note: any) => note.osce_id == this.selectedTitle.ID_OSCE);
            },
            (error) => {
                console.error('Error loading OSCE notes:', error);
            }
        );
    }

    sanitizeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    saveDetails(): void {
        const data = {
            ID_KATEGORI: this.selectedCategory.ID,
            KATEGORI: this.selectedCategory.KATEGORI,
            ID_OSCE: this.selectedTitle.ID,
            JUDUL: this.selectedTitle.TITLE,
            MAHASISWA: this.mahasiswa,
            UNIVERSITAS: this.universitas
        };

        localStorage.setItem('tutorDetails', JSON.stringify(data));
        this.showDialog = false;
        this.hasDetails = true;

        this.getFormDetail();
    }

    clearForm(): void {
        this.selectedLevel = '';
        this.selectedCategory = null;
        this.selectedTitle = null;
        this.mahasiswa = '';
        this.universitas = '';
        this.forms = [];

        localStorage.removeItem('tutorDetails');
        this.hasDetails = false;
        // Do not show dialog automatically
    }

    saveReport(): void {
        if (!this.selectedCategory || !this.selectedTitle || !this.mahasiswa || !this.universitas) {
            this.messageService.add({ severity: 'error', summary: 'Gagal', detail: 'Silakan lengkapi semua kolom' });
            return;
        }
        // Calculate total bobot and skor
        const totalQuestions = this.forms.filter(form => form.IS_HEADER === '0').length;
        const totalBobot = this.forms
            .filter(form => form.IS_HEADER === '0')
            .reduce((sum, form) => sum + (parseInt(form.SKOR, 10) || 0), 0);

        const skor = parseFloat(((totalBobot / (totalQuestions * 3)) * 100).toFixed(2)); // Format to 2 decimal places

        // Construct the data object
        const data = {
            KATEGORI: this.selectedCategory.KATEGORI,
            JUDUL: this.selectedTitle.TITLE,
            MAHASISWA: this.mahasiswa,
            UNIVERSITAS: this.universitas,
            BOBOT: totalBobot,
            SKOR: skor,
            CREATED_BY: this.user.USERNAME,
            FORM: this.forms.map(form => ({
                ID_DETAIL_OSCE: form.ID_DETAIL_OSCE,
                ID_OSCE: form.ID_OSCE,
                IS_HEADER: form.IS_HEADER,
                NO: form.NO,
                ACTIVITY: form.ACTIVITY,
                CREATED_AT: form.CREATED_AT,
                CREATED_BY: form.CREATED_BY,
                UPDATED_AT: form.UPDATED_AT,
                UPDATED_BY: form.UPDATED_BY,
                SKOR: form.SKOR || '0',
                KOMENTAR: form.NOTE || ''
            }))
        };

        this.userService.addTutorReport(data).then(() => {
            this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Laporan berhasil disimpan' });
            this.clearForm();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Gagal', detail: 'Gagal menyimpan laporan' });
        });
    }

    // Get sequential activity number (skipping headers)
    getActivityNumber(index: number): number {
        let activityCount = 0;
        for (let i = 0; i <= index; i++) {
            if (this.forms[i] && this.forms[i].IS_HEADER === '0') {
                activityCount++;
            }
        }
        return activityCount;
    }

    onPrint(result: any): void {
        console.log(result);

        this.fetchingData = true;
        this.userService.detailOsceResult({ ID_REPORT: result.id }).then((response) => {
            const detail = response.data;

            // Kelompokkan data
            const headersAndActivities: any[] = [];
            let activityNumber = 0;
            detail.forEach((item: any) => {
                if (item.IS_HEADER === '1') {
                    headersAndActivities.push({ type: 'header', html: item.ACTIVITY });
                } else {
                    activityNumber++;
                    headersAndActivities.push({
                        type: 'activity',
                        number: activityNumber,
                        html: item.ACTIVITY,
                        skor: item.BOBOT,
                        komentar: item.KOMENTAR || ''
                    });
                }
            });

            // Helper: Convert HTML to pdfmake ops (basic tags: b, strong, ul, ol, li, p)
            function htmlToPdfMakeOps(html: string): any {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                function parseNode(node: any): any {
                    if (!node) return '';
                    if (node.nodeType === 3) return node.textContent; // text node
                    if (node.nodeType !== 1) return '';
                    const tag = node.tagName.toLowerCase();
                    if (tag === 'b' || tag === 'strong') {
                        return { text: node.textContent, bold: true };
                    }
                    if (tag === 'ul' || tag === 'ol') {
                        const items = Array.from(node.children).filter((n: any) => n.tagName && n.tagName.toLowerCase() === 'li');
                        return {
                            [tag === 'ul' ? 'ul' : 'ol']: items.map((li: any) => parseNode(li))
                        };
                    }
                    if (tag === 'li') {
                        return Array.from(node.childNodes).map(parseNode);
                    }
                    if (tag === 'p') {
                        return { text: node.textContent, margin: [0, 2, 0, 2] };
                    }
                    // fallback: parse children
                    return Array.from(node.childNodes).map(parseNode);
                }
                const body = doc.body;
                const children = Array.from(body.childNodes).map(parseNode);
                // Flatten nested arrays
                function flatten(arr: any): any {
                    return Array.isArray(arr) ? arr.reduce((a, b) => a.concat(flatten(b)), []) : [arr];
                }
                return flatten(children).filter((x: any) => x && (typeof x === 'string' || typeof x === 'object'));
            }

            const content: any[] = [
                { text: 'Laporan Hasil OSCE', style: 'header' },
                { text: `ID Laporan: ${result.ID_REPORT}`, margin: [0, 10, 0, 0] },
                { text: `Kategori: ${result.KATEGORI}` },
                { text: `Judul: ${result.JUDUL}` },
                { text: `Nama: ${result.MAHASISWA}` },
                { text: `Universitas: ${result.UNIVERSITAS}` },
                { text: `Tutor: ${result.CREATED_BY}` },
                { text: `Tanggal: ${result.CREATED_AT}`, margin: [0, 0, 0, 10] },
            ];

            // Tambah tabel
            content.push({
                table: {
                    widths: [30, '*', 30, 30, 30, 30, '*'],
                    body: [
                        [
                            { text: 'No', alignment: 'center', bold: true },
                            { text: 'KEGIATAN', bold: true },
                            { text: '0', alignment: 'center', bold: true },
                            { text: '1', alignment: 'center', bold: true },
                            { text: '2', alignment: 'center', bold: true },
                            { text: '3', alignment: 'center', bold: true },
                            { text: 'KOMENTAR', bold: true }
                        ],
                        ...headersAndActivities.map(item => {
                            if (item.type === 'header') {
                                return [
                                    { stack: htmlToPdfMakeOps(item.html), colSpan: 7, bold: true, fillColor: '#f0f0f0' }, '', '', '', '', '', ''
                                ];
                            } else {
                                const checkmark = '√';
                                return [
                                    { text: item.number.toString(), alignment: 'center' },
                                    { stack: htmlToPdfMakeOps(item.html) },
                                    { text: item.skor === '0' ? checkmark : '', alignment: 'center' },
                                    { text: item.skor === '1' ? checkmark : '', alignment: 'center' },
                                    { text: item.skor === '2' ? checkmark : '', alignment: 'center' },
                                    { text: item.skor === '3' ? checkmark : '', alignment: 'center' },
                                    item.komentar
                                ];
                            }
                        })
                    ]
                },
                layout: 'grid',
                margin: [0, 10, 0, 0]
            });

            const documentDefinition: TDocumentDefinitions = {
                pageOrientation: 'landscape',
                pageSize: 'A4',
                content,
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    }
                },
                defaultStyle: {
                    fontSize: 9 // Perkecil font agar muat di kertas
                }
            };
            const filename = `${result.MAHASISWA}-${result.JUDUL}-${result.CREATED_AT}`.replace(/[\s:]/g, '_') + '.pdf';

            pdfMake.createPdf(documentDefinition).download(filename);
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Gagal', detail: 'Gagal membuat PDF.' });
        }).finally(() => {
            this.fetchingData = false;
        });
    }

    // Add this method after existing methods
    selectScore(form: any, score: string): void {
        form.SKOR = score;
    }

    saveOsceNote(): void {
        if (!this.noteContent || this.noteContent.trim() === '') {
            this.messageService.add({
                severity: 'warn',
                summary: 'Peringatan',
                detail: 'Catatan tidak boleh kosong'
            });
            return;
        }

        const userStr = localStorage.getItem('user');
        let userId = '1';
        if (userStr) {
            const user = JSON.parse(userStr);
            userId = user.ID_USER || '1';
        }

        const noteData = {
            USER_ID: userId,
            note: this.noteContent,
            osce_id: this.selectedTitle.ID_OSCE
        };

        this.userService.addNotes(noteData).then(() => {
            this.messageService.add({
                severity: 'success',
                summary: 'Berhasil',
                detail: 'Catatan OSCE berhasil disimpan'
            });
            this.showNotesDialog = false;
            this.noteContent = '';
            this.loadOsceNotes(); // Reload notes to show the new one
        }).catch(err => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Gagal menyimpan catatan'
            });
        });
    }

    editOsceNote(note: any): void {
        this.editingNote = note;
        this.editNoteContent = note.note;
        this.showEditDialog = true;
    }

    updateOsceNote(): void {
        if (!this.editNoteContent || this.editNoteContent.trim() === '') {
            this.messageService.add({
                severity: 'warn',
                summary: 'Peringatan',
                detail: 'Catatan tidak boleh kosong'
            });
            return;
        }

        const userStr = localStorage.getItem('user');
        let userId = '1';
        if (userStr) {
            const user = JSON.parse(userStr);
            userId = user.ID_USER || '1';
        }

        const noteData = {
            id: this.editingNote.id,
            USER_ID: userId,
            note: this.editNoteContent
        };

        this.userService.updateNotes(noteData).then(() => {
            this.messageService.add({
                severity: 'success',
                summary: 'Berhasil',
                detail: 'Catatan berhasil diperbarui'
            });
            this.cancelEdit();
            this.loadOsceNotes();
        }).catch(err => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Gagal memperbarui catatan'
            });
        });
    }

    cancelEdit(): void {
        this.showEditDialog = false;
        this.editingNote = null;
        this.editNoteContent = '';
    }

    deleteOsceNote(note: any): void {
        if (!confirm('Yakin ingin menghapus catatan ini?')) {
            return;
        }

        this.userService.deleteNotes({ id: note.id }).then(() => {
            this.messageService.add({
                severity: 'success',
                summary: 'Berhasil',
                detail: 'Catatan berhasil dihapus'
            });
            this.loadOsceNotes();
        }).catch(err => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Gagal menghapus catatan'
            });
        });
    }

    formatNoteDate(dateString: string): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        // Add 7 hours for Indonesian timezone
        date.setHours(date.getHours() + 7);
        const options: Intl.DateTimeFormatOptions = {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return date.toLocaleDateString('id-ID', options);
    }
}